import { Link, useLocation } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";

const CONTENT = {
  es: {
    "/privacidad": {
      title: "Política de privacidad",
      body: [
        "En HomeHealthy tratamos tus datos personales con la finalidad de gestionar tu solicitud de servicio o tu registro como profesional y poder contactarte.",
        "Responsable: HomeHealthy (Madrid, España). Datos recogidos: nombre, email, teléfono, ciudad y la información que nos facilites en el formulario.",
        "Base legal: tu consentimiento. Conservaremos tus datos mientras sean necesarios para gestionar tu solicitud. No cederemos tus datos a terceros salvo obligación legal.",
        "Puedes ejercer tus derechos de acceso, rectificación y supresión escribiendo a nuestro email de contacto.",
        "Este texto es una versión inicial del MVP y debe ser revisado por un profesional legal antes de un uso definitivo.",
      ],
    },
    "/terminos": {
      title: "Términos y condiciones",
      body: [
        "HomeHealthy es una plataforma que conecta a personas que necesitan servicios para el hogar con personas y profesionales dispuestos a ofrecerlos, empezando en Madrid.",
        "En esta fase inicial (MVP), HomeHealthy recoge solicitudes y candidaturas para poner en contacto a ambas partes. No gestionamos pagos ni garantizamos la contratación.",
        "El uso de la plataforma implica la aceptación de estas condiciones. Esta es una versión inicial que será ampliada.",
      ],
    },
    "/cookies": {
      title: "Política de cookies",
      body: [
        "HomeHealthy utiliza únicamente cookies técnicas necesarias para el funcionamiento del sitio y, en su caso, de medición de uso de forma agregada.",
        "Puedes configurar tu navegador para bloquear o eliminar cookies.",
      ],
    },
  },
  en: {
    "/privacidad": {
      title: "Privacy policy",
      body: [
        "At HomeHealthy we process your personal data to manage your service request or your registration as a professional and to be able to contact you.",
        "Controller: HomeHealthy (Madrid, Spain). Data collected: name, email, phone, city and the information you provide in the form.",
        "Legal basis: your consent. We keep your data as long as needed to manage your request. We do not share your data with third parties except by legal obligation.",
        "You can exercise your rights of access, rectification and erasure by writing to our contact email.",
        "This is an initial MVP version and should be reviewed by a legal professional before final use.",
      ],
    },
    "/terminos": {
      title: "Terms and conditions",
      body: [
        "HomeHealthy is a platform connecting people who need home services with people and professionals willing to offer them, starting in Madrid.",
        "In this initial phase (MVP), HomeHealthy collects requests and applications to connect both parties. We do not manage payments or guarantee hiring.",
        "Using the platform implies acceptance of these terms. This is an initial version that will be expanded.",
      ],
    },
    "/cookies": {
      title: "Cookies policy",
      body: [
        "HomeHealthy only uses technical cookies necessary for the site to work and, where applicable, aggregated usage measurement.",
        "You can set your browser to block or delete cookies.",
      ],
    },
  },
};

export default function LegalPage() {
  const { lang } = useLang();
  const { pathname } = useLocation();
  const c = (CONTENT[lang] || CONTENT.es)[pathname] || CONTENT.es["/privacidad"];
  return (
    <div className="min-h-screen bg-cream">
      <header className="border-b border-line bg-white/90 backdrop-blur">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="font-heading font-extrabold text-lg tracking-tight text-ink flex items-center gap-2"><span className="w-2.5 h-2.5 rounded-full bg-forest" /> HomeHealthy</Link>
          <Link to="/" className="text-sm font-medium text-ink-soft hover:text-ink">Inicio</Link>
        </div>
      </header>
      <div className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="font-heading text-4xl font-light tracking-tight text-ink">{c.title}</h1>
        <div className="mt-8 space-y-5">
          {c.body.map((p, i) => <p key={i} className="text-ink-soft leading-relaxed">{p}</p>)}
        </div>
        <p className="mt-10 text-sm text-ink-faint">Madrid · España · HomeHealthy</p>
      </div>
    </div>
  );
}
